<template>
  <OverlayLoader :visible="isLoading" />
  <div class="card bg-white border-0 rounded-3 mb-4">
    <div class="card-body p-0">
      <div
        class="d-flex row justify-content-center align-items-center flex-wrap gap-2 p-4"
      >
        <form class="position-relative table-src-form me-0" @submit.prevent>
          <div class="row">
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Torneo</label>
                <select
                  v-model="filters.tournamentId"
                  class="form-select form-control h-45"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsTournament"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6">
              <div class="form-group mb-4">
                <label class="label text-secondary strong">Premio</label>
                <select
                  v-model="filters.prizeId"
                  class="form-select form-control h-45"
                  aria-label="Default select example"
                >
                  <option :value="null">{{ LABELS.SELECT_ALL }}</option>
                  <option
                    :value="item.id"
                    v-for="(item, i) of itemsPrizes"
                    :key="i"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-3 col-sm-6 text-end mt-4">
              <div class="d-inline-flex flex-wrap gap-3 justify-content-end">
                <button
                  type="button"
                  @click.prevent="getReport()"
                  class="btn btn-outline-primary py-1 px-3 fw-medium fs-14 hover-bg"
                >
                  Generar reporte
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import OverlayLoader from "@/components/Others/OverlayLoader.vue";
import api from "@/services/api";
import { STATUS, LABELS } from "@/utils/constants";

export default defineComponent({
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Reports_TournamentPlayersPrize",
  components: {
    OverlayLoader,
  },
  setup() {
    const isLoading = ref(false);
    const itemsTournament = ref<any[]>([]);
    const itemsPrizes = ref<any[]>([]);

    const filters = ref({
      tournamentId: null,
      prizeId: null,
    });

    onMounted(async () => {
      await getTournaments();
      await getPrizes();
    });

    const getTournaments = async () => {
      try {
        var params = `pageNumber=1&pageSize=99999&isActive=true`;

        const response = await api.get(`/tournament?${params}`);

        itemsTournament.value = response.data.list;
      } catch (error) {
        console.error(error);
      }
    };

    const getPrizes = async () => {
      try {
        const response = await api.get(`/prize/list`);

        itemsPrizes.value = response.data;
      } catch (error) {
        console.error(error);
      }
    };

    const getReport = async () => {
      try {
        isLoading.value = true;
        var params = `idTournament=${filters.value.tournamentId}`;

        if (
          filters.value.prizeId !== null &&
          filters.value.prizeId !== undefined
        ) {
          params += `&idPrize=${filters.value.prizeId}`;
        }

        const response: any = await api.get(
          `/reports/tournament_players_prizes?${params}`,
          { responseType: "blob" }
        );

        const contentDisposition =
          response.headers["content-disposition"] ||
          response.headers["Content-Disposition"];

        let fileName = "report.xlsx";

        if (contentDisposition) {
          // Try filename* (UTF-8 encoded)
          let utf8FilenameRegex = /filename\*\s*=\s*UTF-8''([^;\n]*)/i;
          let matches = utf8FilenameRegex.exec(contentDisposition);

          if (matches && matches[1]) {
            fileName = decodeURIComponent(matches[1]); // decode UTF-8 filename
          } else {
            // Fallback to plain filename
            let simpleFilenameRegex = /filename\s*=\s*([^;\n]*)/i;
            matches = simpleFilenameRegex.exec(contentDisposition);
            if (matches && matches[1]) {
              fileName = matches[1].replace(/['"]/g, "");
            }
          }
        }
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        a.remove();
      } catch (error) {
        console.error(error);
      } finally {
        isLoading.value = false;
      }
    };

    return {
      itemsTournament,
      itemsPrizes,
      STATUS,
      LABELS,
      OverlayLoader,
      filters,
      isLoading,
      getReport,
    };
  },
});
</script>
